import { render, staticRenderFns } from "./TransparencyBreakdownDialog.vue?vue&type=template&id=ab8c5d5c&scoped=true"
import script from "./TransparencyBreakdownDialog.vue?vue&type=script&lang=js"
export * from "./TransparencyBreakdownDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8c5d5c",
  null
  
)

export default component.exports